import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Redirect } from "react-router-dom";
import { oidcSelector } from "../../../selectors/oidcSelectors";
import { useSelector } from "react-redux";
import LoginOidcForm from "../components/login-oidc-form";

const LoginOrganizationPage = ({ organizations, handleSubmit, isLoading }) => {
  const oidc = useSelector(oidcSelector);
  return (
    <React.Fragment>
      {!oidc.isLoadingUser && (!oidc.user || oidc.user.expired) && (
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <LoginOidcForm
                title="Login"
                handleSubmit={handleSubmit}
                organizations={organizations}
                isLoading={isLoading}
              />
            </Col>
          </Row>
        </Container>
      )}
      {!oidc.isLoadingUser && oidc.user && !oidc.user.expired && (
        <Redirect to="/" />
      )}
    </React.Fragment>
  );
};
export default LoginOrganizationPage;



// WEBPACK FOOTER //
// ./src/features/login/pages/LoginOrganizationPage.jsx